import * as React from "react";

import { useStrings } from "@1js/localization-components";
import {
  OfficeExcelRegular,
  OfficePowerPointRegular,
  OfficeWordRegular,
  type ProductType,
} from "@1js/pl-card-components";
import {
  Menu,
  MenuItem,
  MenuList,
  MenuPopover,
} from "@fluentui/react-components";
import type {
  HandoffFile,
  RecentFiles,
} from "../../services/workingsetfiles-client.web";
import { useHandoffFileSelectionMenu } from "./HandoffFileSelectionMenu.web.hook";
import {
  HandoffFileSelectionMenuNewDocument,
  HandoffFileSelectionMenuOpenCloudFiles,
} from "./HandoffFileSelectionMenu.web.string";

export type HandoffFileSelectionMenuConfiguration = {
  isOpen: boolean;
  product: ProductType | string;
  onAction: (file: HandoffFile | undefined) => void;
  openRef: React.MutableRefObject<null>;
};

export type HandoffFileSelectionMenuProps = {
  product: ProductType | string;
  isOpen: boolean;
  onOpenChange: () => void;
  onAction: (file: HandoffFile | undefined) => void;
  openRef: React.MutableRefObject<null>;
  recentFiles: RecentFiles;
};

export const HandoffFileSelectionMenu: React.FC<
  HandoffFileSelectionMenuProps
> = ({ product, onAction, isOpen, onOpenChange, openRef, recentFiles }) => {
  const {
    recentFilesWithActions,
    positioningRef,
    // CloudAdd24Icon,
    Add24Icon,
    onNewDocument,
    // onCloudDocument,
  } = useHandoffFileSelectionMenu({
    product,
    isOpen,
    onOpenChange,
    onAction,
    openRef,
    recentFiles,
  });

  const brandIcon = (() => {
    switch (product) {
      case "Word":
        return <OfficeWordRegular data-testid="office-word-regular" />;
      case "Excel":
        return <OfficeExcelRegular data-testid="office-excel-regular" />;
      case "PowerPoint":
        return (
          <OfficePowerPointRegular data-testid="office-powerpoint-regular" />
        );
      default:
        return <></>;
    }
  })();

  const localizations = useStrings({
    HandoffFileSelectionMenuNewDocument,
    HandoffFileSelectionMenuOpenCloudFiles,
  });
  return (
    <Menu
      open={isOpen}
      onOpenChange={onOpenChange}
      positioning={{ positioningRef }}
    >
      <MenuPopover>
        <MenuList>
          {recentFilesWithActions?.map(
            (file, index) =>
              file?.fileName && (
                <MenuItem
                  icon={brandIcon}
                  key={`${file.fileName}-${index}`}
                  onClick={file.onAction}
                >
                  {file.fileName}
                </MenuItem>
              )
          )}
          {/* TODO: Reinstate file selecting functionality */}
          {/* <MenuItem
            icon={<CloudAdd24Icon />}
            onClick={onCloudDocument}
            disabled
          >
            {localizations.HandoffFileSelectionMenuOpenCloudFiles()}
          </MenuItem> */}
          <MenuItem icon={<Add24Icon />} onClick={onNewDocument}>
            {localizations.HandoffFileSelectionMenuNewDocument()}
          </MenuItem>
        </MenuList>
      </MenuPopover>
    </Menu>
  );
};
